import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {  RouterModule, } from '@angular/router';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { RegisteredAgentComponent } from './registered-agent/registered-agent.component';
import { LayoutModule } from '@progress/kendo-angular-layout';
import {UploadModule} from '@progress/kendo-angular-upload'
import { UploadComponent } from './upload-component/upload-component.component';
import { UploadInterceptor } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FileSelectModule } from '@progress/kendo-angular-upload';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { ActivateAgentComponent } from './activate-Account/activate-account.component';
import { AccountNotCreatedAuthGard, AuthGard} from './AuthGard';
import { AuthService } from '../Services/AuthService/auth-service.service';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { UpdateContactComponent } from './update-contact/update-contact.component';
import { TokenInterceptor } from '../Services/token.interceptor';
import { ProgressBarModule } from "@progress/kendo-angular-progressbar";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { CommonModule, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LabelModule } from '@progress/kendo-angular-label';
import { DatePickerModule } from "@progress/kendo-angular-dateinputs";
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { SocialsearchComponent } from './socialsearch/socialsearch.component';
import { PdfViewerModule} from 'ng2-pdf-viewer';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    FetchDataComponent,
    SignInComponent,
    RegisteredAgentComponent,
    UploadComponent,
    ActivateAgentComponent,
    UpdateContactComponent,
    PasswordRecoveryComponent,
    ConfirmEmailComponent,
    SocialsearchComponent,
    PdfViewerComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ProgressBarModule,
    DropDownsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    LabelModule,
    DatePickerModule,
    PdfViewerModule,
    
    
    RouterModule.forRoot([
    { path: '', component: RegisteredAgentComponent, pathMatch: 'full' , canActivate:[AuthGard]},
    // { path: 'fetch-data', component: FetchDataComponent , canActivate:[AuthGard]},
    { path: 'sign-in', component: SignInComponent},
    { path: 'registered-agent', component: RegisteredAgentComponent , canActivate:[AuthGard]},
    { path: 'activate-account/:id', component: ActivateAgentComponent },//, canActivate:[AuthGard], canDeactivate:[AccountNotCreatedAuthGard]} 
    { path: 'update-contact/:id', component: UpdateContactComponent },//, canActivate:[AuthGard], canDeactivate:[AccountNotCreatedAuthGard]}
    { path: 'recover-password', component: PasswordRecoveryComponent },//, canActivate:[AuthGard], canDeactivate:[AccountNotCreatedAuthGard]} 
    { path: 'recover-password/:id', component: PasswordRecoveryComponent },//, canActivate:[AuthGard], canDeactivate:[AccountNotCreatedAuthGard]} 
    { path: 'confirm-email/:id', component: ConfirmEmailComponent },
    { path: 'pdf-viewer', component: PdfViewerComponent}
], { relativeLinkResolution: 'legacy' }),
    InputsModule,
    BrowserAnimationsModule,
    ButtonsModule,
    LayoutModule,HttpClientModule, FileSelectModule, UploadModule, NotificationModule, DialogsModule, TooltipModule, GridModule, PDFModule
  ],
  exports: [
  ],
  providers: [
      {provide: LocationStrategy, useClass: HashLocationStrategy},
      {
        provide: HTTP_INTERCEPTORS,
        useClass: UploadInterceptor,
        multi: true
      }, 
      {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true
      }, 
      AuthGard,AccountNotCreatedAuthGard,AuthService,DatePipe
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }



